import styled from "styled-components"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  color: ${(props) => props.theme.a_color_gradients.a_light};
`

const PageTaxo = styled.span`
  & > a {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
    text-decoration: none;
    font-weight: 600;
  }
`
const PageTitle = styled.h1`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`
const PageFooterContainer = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  font-weight: bold;
  & a::before {
    background-color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

export { AdditionalInfos, PageFooterContainer, PageTaxo, PageTitle }
